import { render, staticRenderFns } from "./IncomeDocument.vue?vue&type=template&id=11a479c7&"
import script from "./IncomeDocument.vue?vue&type=script&lang=js&"
export * from "./IncomeDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports